const DEFAULT_AUTH_REDIRECT = "/chat";

export function normalizeInternalPath(
  candidate: string | null | undefined,
  fallback: string = DEFAULT_AUTH_REDIRECT
): string {
  const value = candidate?.trim();
  if (
    !value ||
    !value.startsWith("/") ||
    value.startsWith("//") ||
    /[\\\u0000-\u001f\u007f]/.test(value)
  ) {
    return fallback;
  }

  return value;
}
